import { ActionButton, ActionButtonType, Button } from "@octopusdeploy/design-system-components";
import { ProcessType } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { noOp } from "@octopusdeploy/utilities";
import * as React from "react";
import { Action, useProjectScopedAnalyticActionDispatch } from "~/analytics/Analytics";
import { processScopedEditPermission } from "~/areas/projects/components/Process/Common/CommonProcessHelpers";
import { useProcessContext } from "~/areas/projects/components/Process/Contexts/ProcessContext";
import { useProcessQueryStringContext } from "~/areas/projects/components/Process/Contexts/ProcessQueryString/ProcessQueryStringContext";
import { isRunbookProcessIdentifier } from "~/areas/projects/components/Process/types";
import { useProjectContext } from "~/areas/projects/context/index";
import LicensedFeatureVisibility from "~/components/LicensedFeature/LicensedFeature";
import { PermissionCheck } from "~/components/PermissionCheck/index";
interface AddProcessTemplateStepButtonProps {
    projectId: string;
}
export function AddDeploymentProcessTemplateStepButton({ projectId }: AddProcessTemplateStepButtonProps) {
    const processQueryStringContext = useProcessQueryStringContext();
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectId);
    return (<PermissionCheck permission={processScopedEditPermission(ProcessType.Deployment)} project={projectId} wildcard={true}>
            <LicensedFeatureVisibility feature={"ProcessTemplates"} disabledContent={<DisabledProcessTemplateStepButton />}>
                <ActionButton type={ActionButtonType.Secondary} label="Add Process Template" onClick={() => {
            processQueryStringContext.actions.addProcessTemplateStep();
            dispatchAction("Add Process Template To Process", { resource: "Deployment Process", action: Action.Add });
        }}/>
            </LicensedFeatureVisibility>
        </PermissionCheck>);
}
export function AddRunbookProcessTemplateStepButton({ projectId }: AddProcessTemplateStepButtonProps) {
    const processContext = useProcessContext();
    const processIdentifier = processContext.state.processIdentifier;
    const projectContext = useProjectContext();
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectId);
    if (!isRunbookProcessIdentifier(processIdentifier)) {
        return null;
    }
    const routeValues = {
        spaceId: processIdentifier.spaceId,
        projectSlug: projectContext.state.model.Slug,
        processId: processIdentifier.id,
        runbookId: processIdentifier.runbookId,
    };
    const href = links.runbookProcessEditorPage.generateUrl(routeValues, { new: true, actionType: "Octopus.ProcessTemplate" });
    const logAction = () => dispatchAction("Add Process Template To Process", { resource: "Runbook Process", action: Action.Add });
    return (<PermissionCheck permission={processScopedEditPermission(ProcessType.Runbook)} project={projectId} wildcard={true}>
            <LicensedFeatureVisibility feature={"ProcessTemplates"} disabledContent={<DisabledProcessTemplateStepButton />}>
                <Button label={"Add Process Template"} href={href} importance="secondary" onClick={logAction}/>
            </LicensedFeatureVisibility>
        </PermissionCheck>);
}
function DisabledProcessTemplateStepButton() {
    return <Button label={"Add Process Template"} disabled={true} onClick={noOp} importance={"secondary"} title={"Process Templates are only available on the Enterprise tier \u2014 contact sales@octopus.com to learn more."}/>;
}
